var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtsAnketa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.8573 22.2862",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 13850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6744 3.54789C13.6749 3.13704 13.381 2.76581 12.9285 2.60531L12.0517 2.29352C11.2882 2.02255 10.7928 1.39657 10.7937 0.703742C10.793 0.315503 10.4167 0.000909757 9.95194 0.000509511H8.90554C8.4408 0.000909757 8.06421 0.315503 8.06373 0.703742C8.06469 1.39657 7.56904 2.02255 6.80581 2.29352L5.92878 2.60531C5.47601 2.76581 5.18231 3.13704 5.18279 3.54789V4.30776H13.6744V3.54789Z",
    fill: "url(#paint0_linear_0_380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0175 3.8849H14.901V4.32504C14.901 4.60801 14.6265 5.0767 14.2877 5.0767H4.56976C4.23103 5.0767 3.95649 4.60801 3.95649 4.32504V3.8849H1.83998C0.824254 3.8859 0.00136763 4.57332 0.000169837 5.42185V20.7493C0.00136763 21.5978 0.824254 22.2852 1.83998 22.2862H17.0175C18.0332 22.2852 18.8564 21.5978 18.8573 20.7493V5.42185C18.8564 4.57332 18.0332 3.8859 17.0175 3.8849Z",
    fill: "url(#paint1_linear_0_380)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.58033 12.4745C4.76714 14.8571 6.88743 17.002 8.92558 19.7148C11.1415 15.2768 13.4095 10.8234 17.1518 6.00051C13.9919 9.37499 10.5285 13.1576 8.39536 16.9536C6.91195 15.6081 4.04413 13.4528 2.58033 12.4745Z",
    fill: "var(--fill-0, #101010)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_380",
    x1: -3.16888,
    y1: 46.2434,
    x2: -23.3056,
    y2: 31.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_380",
    x1: -3.16888,
    y1: 46.2434,
    x2: -23.3056,
    y2: 31.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtsAnketa);
export default __webpack_public_path__ + "static/media/pts_anketa.d6d193b1056510cf6ced15501e03ba77.svg";
export { ForwardRef as ReactComponent };